import React, { useEffect, useRef, useState } from "react";
import {
    
    useGetSubServiceOnIdBasisDataQuery,
} from "../../Services/vehicle/Vehicle";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import axios from "axios";

import { useLocation, useNavigate } from "react-router-dom";


interface IPROPS {
    services: any;
    activeServiceId: any;
    setActiveServiceId: any;
    storedGeoLoaction: any;
    storeVehicleInfo: any;
    setStoreVehicleInfo: any;
}

const SelectedServiceHeader: React.FC<IPROPS> = ({
    services,
    activeServiceId,
    setActiveServiceId,
    storedGeoLoaction,
    storeVehicleInfo,
    setStoreVehicleInfo,
}) => {

    const [getServiceId, setGetServiceId] = useState("");
    const [subServicesName, setSubServicesName] = useState([]);
    const [hoveredServiceId, setHoveredServiceId] = useState<string | null>(
        null
    );
    const [cartItems, setCartItems] = useState<any[]>([]);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [openVehicleModal, setOpenVehicleModal] = useState(false);
    const [workshopId, setWorkshopId] = useState("");
    const [vehiclesData, setVehiclesData] = useState([]);
    const [isCheckoutClicked, setIsCheckoutClicked] = useState(false);
    const [liftingSlot, setLiftingSlot] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    console.log(cartItems)

    const navigate = useNavigate()

    const fetchVehicle = async () => {
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setVehiclesData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    useEffect(() => {
        fetchVehicle();
    }, []);

    const pointers = [
        {
            tasks: [
                "Replace Engine Oil",
                "Top up Gear Oil",
                "Top up Battery Water",
                "Replace Engine Oil Filter",
                "Top up Power Steering Oil/clutch Oil",
                "Top up Wiper Water",
                "Top up Brake Oil",
                "Top up Coolant",
                "Doors Greasing",
                "Top up Tyre Pressure",
                "Wash",

            ],
        },
    ];

    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (el) {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollWidth > el.clientWidth + el.scrollLeft);
    }
  };

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: "smooth" });
  };
  

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      return () => {
        el.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, []);

    const { data: subService } = useGetSubServiceOnIdBasisDataQuery(
        activeServiceId || getServiceId
    );

    useEffect(() => {
        if (subService) {
            setSubServicesName(subService);
        }
    }, [subService]);

    useEffect(() => {
        const storedCart = sessionStorage.getItem("cartItems");
        if (storedCart) {
            setCartItems(JSON.parse(storedCart));
        }
    }, []);

    console.log(cartItems, "cartItemss")

    const updateSessionStorage = (updatedCart: any[]) => {
        sessionStorage.setItem("cartItems", JSON.stringify(updatedCart));
    };

    const handleAddToCart = (service: any, sub_service: any) => {
        const alreadyAdded = cartItems.some(
            (item) => item.sub_service?.id === sub_service.id
        );
        if (!alreadyAdded) {
            const newItem = { service, sub_service };
            const updatedCart = [...cartItems, newItem];
            setCartItems(updatedCart);
            updateSessionStorage(updatedCart);
        }
    };

    const handleRemoveFromCart = (subServiceId: string) => {
        const updatedCart = cartItems.filter(
            (item) => item.sub_service?.id !== subServiceId
        );
        setCartItems(updatedCart);
        updateSessionStorage(updatedCart);
    };

    const token = localStorage.getItem("customer-token");

    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;

    const checkoutServices = () => {
        setIsCheckoutClicked(true);
    };


    const isSubServiceInCart = (subServiceId: any) => {
        console.log(subServiceId, "wdcsdcdscscscd")


        return cartItems?.some((item) => item?.sub_service?.id === subServiceId);
    };

    const closeModal = () => {
        setOpenVehicleModal(false);
    };

    useEffect(() => {
        if (isCheckoutClicked) {
            setIsCartOpen(false);
        }
    }, [isCheckoutClicked]);

    console.log(activeServiceId, "activeServiceIddd")

    useEffect(() => {
        if (!activeServiceId) {
            navigate('/customer/service')

        }

    }, [activeServiceId])

    return (
        <div
            style={{
                // height: "80vh",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                background: "white",
                borderBottomRightRadius: "20px",
                borderBottomLeftRadius: "20px"
            
            }}
        >
            <div
                style={{
                    background: "white",
                    padding: "5px 10px",
                    paddingBottom: "0px",
                }}
            >
                {/* Cart Icon */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        paddingRight: "20px",
                    }}
                >
                    <div>
                        <i
                            className="bi bi-car-front-fill"
                            style={{
                                fontSize: "20px",
                                color: "rgb(242, 93, 33)",
                            }}
                            onClick={() => setOpenVehicleModal(true)}
                        ></i>
                    </div>

                    <div
                        style={{ cursor: "pointer", position: "relative" }}
                        onClick={() => setIsCartOpen(true)}
                    >
                        <ShoppingCartIcon
                            style={{ color: "#F25D21", fontSize: 30 }}
                        />
                        <span
                            style={{
                                position: "absolute",
                                top: -5,
                                right: -10,
                                backgroundColor: "red",
                                color: "white",
                                borderRadius: "50%",
                                padding: "2px 6px",
                                fontSize: "12px",
                            }}
                        >
                            {cartItems?.length}
                        </span>
                    </div>
                </div>

                {/* Services */}
            <div style={{ display: "flex", alignItems: "center", position: "relative", gap: "10px", borderBottom: "1px solid #E5E5E5" }}>
      <button
        onClick={scrollLeft}
        disabled={!canScrollLeft}
        style={{
          cursor: canScrollLeft ? "pointer" : "not-allowed",
          right: 0,
          top: "50%",
          zIndex: 1,
          padding: "5px 7px",
          borderRadius: "40px",
            border: !canScrollLeft ? "0.2px solid #D8D8D8" : "0.2px solid rgb(248, 233, 227)",
          background: !canScrollLeft ? "#fff" : "rgb(248, 233, 227)",
        }}
      >
                <i className="bi bi-chevron-left" style={{color: !canScrollLeft ? "grey" : "orange",}}></i>

      </button>

      <div
        ref={scrollRef}
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "baseline",
          width: "1500px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          padding: "10px 0"

        }}
      >
        {services?.map((service) => {
          const isSelected = getServiceId === service?.id;
          const isActive = activeServiceId === service?.id;
          const isHovered = hoveredServiceId === service?.id;

          const textColor = isSelected || isHovered || isActive ? "rgb(242, 93, 33)" : "#A9A9A9";

          return (
            <div
              key={service?.id}
              onClick={() => {
                setGetServiceId(service?.id);
                setActiveServiceId(service?.id);
              }}
              onMouseEnter={() => setHoveredServiceId(service?.id)}
              onMouseLeave={() => setHoveredServiceId(null)}
              style={{
                background: "transparent",
                color: textColor,
                border: isSelected || isActive ? "1px solid #F25D215C" : "1px solid #D8D8D8",
                borderRadius: "30px",
                padding: "5px 20px",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontSize: isSelected || isActive ? "22px" : "20px",
                  letterSpacing: isSelected || isActive ? "1px" : "",
                  whiteSpace: "nowrap",
                }}
              >
                {capitalizeFirstLetter(service?.name)}
              </span>
            </div>
          );
        })}
      </div>

      <button
        onClick={scrollRight}
        disabled={!canScrollRight}
        style={{
       position: "absolute",
          right: 0,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
        //   background: "#fff",
          cursor: "pointer",
          padding: "5px 7px",
          borderRadius: "40px",
            border: !canScrollRight ? "0.2px solid #D8D8D8" : "0.2px solid rgb(248, 233, 227)",
          background: !canScrollRight ? "#fff" : "rgb(248, 233, 227)",


        }}
      >
                <i className="bi bi-chevron-right" style={{color: !canScrollRight ? "grey" : "orange"}}></i>

      </button>
    </div>
            </div>

            {/* Sub service start */}
            <div style={{ background: "white", padding: "10px", display: "flex", flexDirection: "column", gap: "20px", height: "80%"}}>
                {subServicesName?.map((sub_service, index) => (
                    <div style={{display: "flex", justifyContent: "space-between", gap: "20px", height: "80%"}}>
                    <div
                        key={index}
                        style={{
                            background: "white",
                            width: "70%",
                            height: "90%",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            // marginBottom: "20px",
                            padding: "10px 20px",
                            paddingBottom: "10px",
                            borderRadius: "5px",
                            position: "relative",
                            border: "1px solid #EDEDED",
                            justifyContent: "space-between"

                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    width: "100%",
                                }}
                            >
                                <p
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        width: "100%",
                                        alignItems: "center",
                                        marginTop: "15px"
                                    }}
                                >
                                    
                                    <span style={{fontSize: "18px"}}>{sub_service?.name}</span>
                                    <span >
                                        <button
                                            style={{
                                                padding: "5px 10px",
                                                backgroundColor:
                                                    isSubServiceInCart(
                                                        sub_service.id
                                                    )
                                                        ? "gray"
                                                        : "#F8E9E3",
                                                color: isSubServiceInCart(sub_service?.id) ? "white" : "#F25D21",
                                                border: isSubServiceInCart(sub_service?.id) ? "none" : "1px solid #F25D21",
                                                borderRadius: "20px",
                                                fontSize: "14px",
                                            }}
                                            onClick={() => {
                                                if (!storeVehicleInfo?.id) {
                                                    // Open modal if vehicle info is missing
                                                    setOpenVehicleModal(true);
                                                } else {
                                                    // Proceed with add to cart if vehicle info exists
                                                    const service =
                                                        services?.find(
                                                            (s: any) =>
                                                                s.id ===
                                                                (activeServiceId ||
                                                                    getServiceId)
                                                        );
                                                    handleAddToCart(
                                                        service,
                                                        sub_service
                                                    );
                                                }
                                            }}
                                            disabled={isSubServiceInCart(
                                                sub_service.id
                                            )}
                                        >
                                            <span style={{fontSize: "16px", marginRight: "10px"}}>+</span><span>{isSubServiceInCart(sub_service.id)
                                                ? "Added to Cart"
                                                : "Add to Cart"}</span>
                                    
                                        </button>
                                    </span>
                                </p>
                            </div>

                            <div style={{ width: "100%" }}>
                                {pointers.map((point, index) => (
                                    <div
                                        key={index}
                                        style={{ marginBottom: "20px" }}
                                    >
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                    "repeat(3, 1fr)",
                                                gap: "10px",
                                            }}
                                        >
                                            {point?.tasks?.map(
                                                (task, taskIndex) => (
                                                    <div
                                                        key={taskIndex}
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            gap: "6px",
                                                        }}
                                                    >
                                                                <span style={{  fontSize: "10px"}}><i className="bi bi-check2-circle" style={{background: "#F25D212E", color: "#F25D21"}}></i></span>

                                                        <span style={{fontSize: "16px"}}>{task}</span>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>

                            <p
                                style={{
                                    margin: "0",
                                    color: "rgba(220, 53, 69)",
                                }}
                            >
                                * Spare part replacements charged at actual
                                cost. Service packages use company-recommended
                                oil and filters.
                            </p>
                        </div>
                    </div>
                    <div style={{height: "90%", flex: "1"}}>  <img
    src={sub_service.image}
    alt={sub_service.name || "Subservice Image"}
    style={{ width: "100%", height: "100%"}}
  />
</div>
                    </div>
                ))}
            </div>

           

            {/* {(openVehicleModal || vehiclesData?.length === 0) &&  (
                <VehicleModal
                    vehicle={""}
                    // onSave={handleSaveVehicle}
                    onClose={closeModal}
                    fetchVehicle={fetchVehicle}
                />
            )} */}

            {/* {!openVehicleModal &&
                vehiclesData?.length > 0 &&
                !storeVehicleInfo?.id && (
                    <VehicleSelect
                        vehicleData={vehiclesData}
                        storeVehicleInfo={storeVehicleInfo}
                        setStoreVehicleInfo={setStoreVehicleInfo}
                    onClose={closeModal}


                    />
                )} */}

            {/* Cart Modal */}
            
        </div>
    );
};

export default SelectedServiceHeader;
